module.exports = __webpack_public_path__ + "static/img/live.0596aade.png";